import 'notyf/notyf.min.css';
import { Notyf } from 'notyf';

(function () {
  const options = {
    duration: 5000,
    dismissible: true,
    position: {
      x: 'right',
      y: 'top'
    },
    types: [
      {
        type: 'success',
        icon: false,
        background: '#23BE87'
      },
      {
        type: 'error',
        icon: false,
        background: '#F1173A'
      },
      {
        type: 'warning',
        background: '#F1B617',
        icon: false
      },
      {
        type: 'info',
        background: '#35ABFC',
        icon: false
      }
    ]
  };

  const init = () => {
    window.toastr = new Notyf(options);
    window.toastr.warning = message =>
      toastr.open({ type: 'warning', message });
    window.toastr.info = message => toastr.open({ type: 'info', message });
  };

  document.addEventListener('turbolinks:load', () => {
    init();
  });

  init();
})();
